import { render } from "./TestAdministration.vue?vue&type=template&id=0f383e79&scoped=true&lang=html"
import script from "./TestAdministration.vue?vue&type=script&lang=js"
export * from "./TestAdministration.vue?vue&type=script&lang=js"

import "./TestAdministration.vue?vue&type=style&index=0&id=0f383e79&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0f383e79"

export default script